<template>
  <fvSelect class="form-control select text-right fv-size-md"
            v-model="valData"
            :options="stories"
            :placeholder="placeholder"
            text-key="title" value-key="id"
            :search="true"
            :multiple="multiple"
            @search="fetchData"
            :loading="loading"
  >

    <template slot="value" slot-scope="scope">
      {{findValueObject(scope.value).title}}
    </template>
    <template slot="option" slot-scope="scope">
      <div class="imageWithName">
            <span class="dropdown-item-text">
              <b>{{scope.option.title || "---"}} </b>
            </span>

        <div class="dropdown-item-text">
          <img class="icon"
               v-if="scope.option.banner && scope.option.banner.path"
               :src="`${media_url}/${scope.option.banner.path}`"/>

          <div v-else>
            <i class="far fa-kiss-beam defaultIcon"/>
          </div>
        </div>
      </div>

    </template>
  </fvSelect>
</template>

<script>
  import {mapActions} from "vuex"
  import {API_MEDIA_URL} from "../env"

  export default {
    props: {
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String
      },
      id: {
        type: String
      },
      type: {
        type: String,
        default: null
      },
      value: {
        type: [Array, String]
      },
      justId: {
        type: Boolean,
        default: false
      },
      required: [Boolean, Function],
    },
    data() {
      return {
        ...mapActions('main', [
          'crud'
        ]),
        stories: [],
        loading: false,
        q: null,
        filters: {},
        timingFetch: null,
        media_url: API_MEDIA_URL
      }
    },
    async created() {

      await this.getData(true)

    },
    computed: {
      valData: {
        get() {
          return this.value ? this.justId ? [this.value] : this.value : this.multiple ? [] : undefined
        },
        set(value) {
          const data = this.multiple ? value : [value]
          const result = this.justId ? data[0] : data
          this.$emit('input', result)
        }
      }
    },
    methods: {
      async getData(first = false) {

        const filters = {}
        if (this.type)
          filters.roles = this.type

        if (first)
	        if (this.value && this.value.length) {
		        const $in = this.multiple ? this.value : [this.value]
		        filters.id = {"$in": $in}
	        }
 

        try {

          const query = this.$queryGenerator(filters, '')
          const q = `${this.q ? `${query ? '&' : ''}q=${this.q}` : ''}`
          this.loading = true
          const user = await this.crud({
            action: 'get',
            section: 'stories',
            query: `${query}${q}`,
            perPage: 40
          })
          if (user.data && user.data.items) {
            const result = user.data.items
            this.stories = result
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
        }
      },
      fetchData(event) {

        clearTimeout(this.timingFetch)
        this.timingFetch = setTimeout(async () => {

          if (!event.trim()) {
            this.stories = []
            this.loading = false
            return false
          }
          this.q = event
          await this.getData()

        }, 1000)
      },
      findValueObject(value) {
        if (this.multiple)
          return this.stories.find((option) => option.id === value) || false;
        else
          return this.stories.find((option) => option.id === value[0]) || false;
      },

    }
  }
</script>

<style lang="scss">

</style>
